import $ from 'jquery';

// --------------------------------------
// **** jQuery trigger-native event ****
// --------------------------------------

// @ts-ignore
if (!$.triggerNative) {
	/**
	 * Triggers a native event. This will also be visible for native
	 * event listeners, unlike jQuery events. The native event will
	 * bubble and be (formally) cancelable.
	 * Returns the jQuery chain
	 * @param {string | Event} type The event type name
	 * @param {Object} data An object containing additional event properties to be set. (Optional)
	 */
	$.fn.triggerNative = function(type, data) {
		return this.each(function() {
			const thisEvent = (type instanceof Event) ? type : new CustomEvent(type, {
				bubbles: true,
				cancelable: true,
				...data,
			});
			this.dispatchEvent(thisEvent);
		});
	};
}